import { Dialog, Toolbar } from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import styles from "./GoToSharedSpace.module.less";
import { ReactElement } from "react";

type GoToSharedSpaceProps = {
	onClose: () => void;
};

export const GoToSharedSpace = (props: GoToSharedSpaceProps): ReactElement => {
	const { onClose } = props;

	return (
		<>
			<Dialog.Body>
				<h2 className={styles.message}>
					{localize("_GoToSharedSpaceToAddTiles")}
				</h2>
			</Dialog.Body>
			<Dialog.Footer>
				<Toolbar>
					<Toolbar.Button
						kind="secondary"
						onClick={onClose}
						text={localize("_Close")}
						responsiveBehavior="hide"
					/>
				</Toolbar>
			</Dialog.Footer>
		</>
	);
};

GoToSharedSpace.displayName = "GoToSharedSpace";
